import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { Archive, Ban, Flag } from 'lucide-react'

function MenuItem({ icon: Icon, label, onClick, danger }) {
  return (
    <button
      onClick={onClick}
      className={`w-full flex items-center gap-3 px-4 py-3 text-left text-sm transition-colors ${
        danger ? 'text-red-600 hover:bg-red-50' : 'text-gray-700 hover:bg-gray-50'
      }`}
    >
      <Icon className="w-4 h-4" />
      {label}
    </button>
  )
}

MenuItem.propTypes = {
  icon: PropTypes.elementType.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  danger: PropTypes.bool
}

function ConversationActionsMenu({ onArchive, onBlock, onReport, onClose }) {
  const menuRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [onClose])

  return (
    <div
      ref={menuRef}
      className="absolute right-0 top-full mt-1 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-50"
    >
      <MenuItem icon={Archive} label="Archive" onClick={onArchive} />
      <MenuItem icon={Flag} label="Report Issue" onClick={onReport} danger />
      <MenuItem icon={Ban} label="Block User" onClick={onBlock} danger />
    </div>
  )
}

ConversationActionsMenu.propTypes = {
  onArchive: PropTypes.func.isRequired,
  onBlock: PropTypes.func.isRequired,
  onReport: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
}

export default ConversationActionsMenu
